import { ContentGroupViewFactory } from 'common/module/content-group/view.factory';
import { StatsService } from 'common/service/stats/service';
import { TermsAndConditionsPageView } from 'desktop/module/terms-and-conditions/page/view';

export function TermsAndConditionsPageViewFactory(): TermsAndConditionsPageView {
  return new TermsAndConditionsPageView(ContentGroupViewFactory(), StatsService());
}
